/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Split_On_DashInputs */



/**
* | output |
* | --- |
* | "Split on Dash" |
*
* @param {Split_On_DashInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_on_dash = /** @type {((inputs?: Split_On_DashInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_On_DashInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Séparer sur le tiret")
	if (locale === "de") return /** @type {LocalizedString} */ ("Split on Dash")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dividi su Dash")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разделение на приборной панели")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dividir en el tablero")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("冲刺分")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダッシュで分割")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डैश पर विभाजित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dividir no painel")
	return /** @type {LocalizedString} */ ("Split on Dash")
});